// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { myAccountDashboardSideNavStyles } from "@pace/App/Widgets/MyAccount/MyAccountDashboardSideNav";
import IconLogOut from "@pace/XDL/Icons/IconLogOut";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, createLinkIconStyles, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

myAccountDashboardSideNavStyles.container = {
    css: css`
        border: 1px solid ${getColor("common.border")};
        border-radius: 4px;
    `,
};

myAccountDashboardSideNavStyles.personalInfo = {
    wrapper: {
        css: css`
            padding: 17px 17px 0px 17px;
            display: flex;
            column-gap: 16px;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-bottom: 20px;
        `,
    },
    infoWrapper: {
        css: css`
            width: 100%;
        `,
    },
    title: {
        variant: "h5",
        css: css`
            flex-basis: 100%;
            margin-bottom: 12px;
        `,
    },
    shipToInfo: {
        size: 12,
        weight: fontConfig.weight.regular,
        lineHeight: "13px",
        css: css`
            display: block;
            width: 100%;
            margin-bottom: 4px;
        `,
    },
    address: {
        size: 12,
        weight: fontConfig.weight.regular,
        lineHeight: "17px",
        css: css`
            display: block;
            width: 100%;
            padding-bottom: 20px;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
    link: {
        ellipsis: true,
        lineHeight: "16px",
        color: "text.link",
        size: "12px",
        weight: fontConfig.weight.semiBold,
        css: css`
            display: flex;
            margin-bottom: 5px;
            letter-spacing: 0;
            align-items: center;
            ${IconWrapper} {
                margin-right: 4px;
                opacity: 0.5;
            }
        `,
    },
};
myAccountDashboardSideNavStyles.actionSection = {
    wrapper: {
        css: css`
            padding: 0px 17px 17px 17px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            flex-wrap: wrap;
            width: 100%;
        `,
    },
    signOutButton: {
        ...createLinkIconStyles(IconLogOut, {
            icon: {
                position: "right",
            },
            css: css`
                width: 100%;
                padding-top: 16px;
                margin-top: 8px;
                justify-content: flex-end;
                border-top: 1px solid ${color("common.border")};
            `,
        }),
    },
    changeCustomerButton: {
        variant: "primary",
        css: css`
            width: 100%;
            margin-top: 16px;
        `,
    },
};
myAccountDashboardSideNavStyles.linkGroup = {
    css: css`
        padding: 0 9px;
    `,
};
